import { render } from "./TwoColumnChart.vue?vue&type=template&id=6679f3e9&scoped=true"
import script from "./TwoColumnChart.vue?vue&type=script&lang=js"
export * from "./TwoColumnChart.vue?vue&type=script&lang=js"

import "./TwoColumnChart.vue?vue&type=style&index=0&id=6679f3e9&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6679f3e9"]])

export default __exports__